import axios from 'axios';
import QS from 'qs';
import {
	Toast
} from 'vant'
// import store from '../store'

// let baseUrl = '';
// if (process.env.NODE_ENV == 'development') {
//     baseUrl = 'http://119.3.240.250:8082/';

// } else if (process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'test') {
//     baseUrl = 'http://119.3.240.250:8082/';
// }



axios.defaults.timeout = 10000; //设置请求时间
//axios.defaults.baseURL = baseUrl;//设置默认接口地址
axios.defaults.headers.post['Content-Type'] = 'application/json';

/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */

export function get(url, params) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: params
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {
	return new Promise((resolve, reject) => {
		axios.post(url, params)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				Toast("服务器错误")
				resolve(err.data)
			})
	});
}

/// 管理端 带 token 的请求----------------------------------------

/** 
 * _post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 * @param {Object} IsHeaders [是否需要 token 验证 默认true] 
 * 
 */

export function _post(url, params, {
	IsHeaders = true
} = Boolean) {
	return new Promise((resolve, reject) => {
		let header = IsHeaders ? {
			headers: {
				'Authorization': localStorage.getItem('userToken')
			}
		} : undefined
		axios.post(url, params, header)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err)
			})
	});
}
// 提交订单用的token
export function _posts(url, params, {
	IsHeaders = true
} = Boolean) {
	return new Promise((resolve, reject) => {
		let header = IsHeaders ? {
			headers: {
				'Authorization': localStorage.getItem('orderToken')
			}
		} : undefined
		axios.post(url, params, header)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err)
			})
	});
}
/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 * @param {Object} IsHeaders [是否需要 token 验证 默认true] 
 */

export function _get(url, params, {
	IsHeaders = true
} = Boolean) {
	return new Promise((resolve, reject) => {
		let header = IsHeaders ? {
			'Authorization': store.state.manage.manageToken
		} : undefined
		axios.get(url, {
				params: params,
				headers: header
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}

/** 
 * _post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 * @param {Object} IsHeaders [是否需要 token 验证 默认true] 
 * 
 */
export function _postNew(url, params, {
	IsHeaders = true
} = Boolean) {
	return new Promise((resolve, reject) => {
		let header = IsHeaders ? {
			headers: {
				'Authorization': localStorage.getItem('userTokenNew')
			}
		} : undefined
		axios.post(url, params, header)
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err)
			})
	});
}
export function _getNew(url, params, {
	IsHeaders = true
} = Boolean) {
	return new Promise((resolve, reject) => {
		let header = IsHeaders ? {
			'Authorization': localStorage.getItem('userTokenNew')
		} : undefined
		axios.get(url, {
				params: params,
				headers: header
			})
			.then(res => {
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}